import { FC, SVGProps } from 'react';

export const AlertIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg width='30' height='30' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
		<path
			d='M0 15C0 6.71573 6.71573 0 15 0C23.2843 0 30 6.71573 30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15Z'
			fill='#F2AF00'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M15 9.375C11.8934 9.375 9.375 11.8934 9.375 15C9.375 18.1066 11.8934 20.625 15 20.625C18.1066 20.625 20.625 18.1066 20.625 15C20.625 11.8934 18.1066 9.375 15 9.375ZM8.25 15C8.25 11.2721 11.2721 8.25 15 8.25C18.7279 8.25 21.75 11.2721 21.75 15C21.75 18.7279 18.7279 21.75 15 21.75C11.2721 21.75 8.25 18.7279 8.25 15Z'
			fill='white'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M14.4375 17.75C14.4375 17.4393 14.6893 17.1875 15 17.1875H15.0069C15.3175 17.1875 15.5694 17.4393 15.5694 17.75V17.7569C15.5694 18.0675 15.3175 18.3194 15.0069 18.3194H15C14.6893 18.3194 14.4375 18.0675 14.4375 17.7569V17.75Z'
			fill='white'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M15 11.6875C15.3107 11.6875 15.5625 11.9393 15.5625 12.25V15C15.5625 15.3107 15.3107 15.5625 15 15.5625C14.6893 15.5625 14.4375 15.3107 14.4375 15V12.25C14.4375 11.9393 14.6893 11.6875 15 11.6875Z'
			fill='white'
		/>
	</svg>
);
